import "./header.js";
import "./scroll-events.js";
import "./carousels.js";
import "./form.js";

const copyrightYear = document.querySelector("footer .year");

copyrightYear.textContent = new Date().getFullYear();
